<div class="d-flex flex-column">
  <div class="d-flex">
    <div class="d-flex align-items-center">
      <span class="title-2">
        EMPLOYEE NAME
      </span>
      <span class="title-3">
        {{customFieldModel?.firstName}} {{customFieldModel?.lastName}}
      </span>
    </div>
    <div class="Vector"></div>
    <div class="d-flex align-items-center">
      <span class="title-2">
        EMPLOYEE NUMBER
      </span>
      <span class="title-3">
        {{customFieldModel?.employeeId}}
      </span>
    </div>
    <div class="Vector"></div>
    <div class="d-flex align-items-center">
      <span class="title-2">
        ROLE
      </span>
      <span class="title-3">
        {{customFieldModel?.role}}
      </span>
    </div>
    <div class="Vector"></div>
    <div class="d-flex align-items-center">
      <span class="title-2">
        SEG
      </span>
      <span class="title-3">
        {{seg?.name}}
      </span>
    </div>
  </div>

  @if (!parametersLoaded) {
    <div>
      <img src="assets/images/loader.gif">
    </div>
  } @else {
    @for (parameter of parameters; track trackById($index, parameter)) {
      <div>
        <div class="Particulates" [style.border-left]="'8px solid ' + parameterColorByParamId.get(parameter.id)">
          <div class="row first-row">
            <div class="col-6">
              <span class="Department-Helper-C">
                ANALYTE
              </span>
            </div>
            <div class="col-6">
              <img src="./assets/images/Vector.svg">
            </div>
          </div>
          <div class="row first-row">
            <div class="col-6">
              <div class="Department-Helper">
                {{parameter?.analyteName}}
              </div>
              <div>
                @if (sensorLabResults && sensorLabResults.length > 0) {
                  @if (selectedLabResultsByParamId.get(parameter.id)) {
                    <div class="gravimetric-sec">
                      <app-gravimetric-results class="w-100 gravimetrics"></app-gravimetric-results>
                    </div>
                  }
                }
              </div>
              <div class="severity">
                <span class="sev">{{ 'SEVERITY' | translate }}</span>
              </div>
            </div>
            <div class="col-6" [style.backgroundColor]="parameterColorOpaqueByParamId.get(parameter.id)">
              <div>
                <span class="title-3">
                  Important Health Advisory:
                </span>
              </div>
              <div>
                <span class="title-red">
                  {{parameter?.healthAdvisory}}
                </span>
              </div>
              <div>
                <div class="rec-actions-title">
                  <span class="title-3">
                    Recommended Action for this type of exposure
                  </span>
                </div>
                <div>
                  @if (parameter?.specificRecommendations) {
                    <ul class="rec-actions">
                      <li>
                        <span class="title-red">{{parameter?.specificRecommendations.split('•')[0].trim()}}.</span>
                      </li>
                      <li>
                        <span class="title-red">{{parameter?.specificRecommendations.split('•')[1].trim()}}.</span>
                      </li>
                    </ul>
                  }
                </div>
              </div>
              <div>
                <div class="Activities">
                  <span class="title-3">{{ 'Activities Contributing to Significant Exposure' | translate }}</span>
                </div>
                <div class="Activities-tasks">
                  <div>
                    @for (task of taskAssignmentDataSource; track trackByIndex($index); let isLast = $last) {
                      <span class="task-names">
                        {{ task?.taskName }} @if (!isLast) {
                        , &nbsp;&nbsp;
                      }
                    </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
<div>
  @if (parametersLoaded) {
    <hr class="w-100">
  }
</div>
@if (selectedRisk) {
  <div class="report-chart-holder">
    <app-report-chart (graphLoaded)="onGraphReady($event)" [selectedParameter]="selectedRisk" class="report-chart"></app-report-chart>
  </div>
}

<div>
  <span class="title-1">
    PPE
  </span>
</div>
<hr class="w-100">
<span class="title-3">
  RESPIRATORY
</span>
<div>
  @for (ppe of ppeAssignments; track trackById($index, ppe); let isLast = $last) {
    <img [src]="$safeNavigationMigration(ppe?.iconUrl)" [alt]="$safeNavigationMigration(ppe?.name)">
    @if (!isLast) {
      <span>&nbsp;&nbsp;</span>
    }
      <span>Model: {{ppe?.name.split(' APF=')[0]}}</span>
      <span>APF: {{ ppe?.name.includes('APF=') ? ppe?.name.split('APF=')[1] : '0' }}</span>
    
}
  </div>
  <div class="infoPPE">
    <span class="Site-A">
      What does this mean for you?
    </span>
    <p class="Site-A-Text">
      Follow PPE activity requirements at all times. If unsure what PPE to use for a task, consult your Supervisor or the EH&S Department for direction.
    </p>
  </div>
  <div class="row mb-5">
    <div class="col-3">
      <span class="Site-Safety-Representative">
        Site Safety Representative
      </span>
    </div>
    <div class="col-9">
      <span class="Employee">
        Employee
      </span>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-3">
      <span class="Signed-Date">
        Signed
      </span>
    </div>
    <div class="col-9">
      <span class="Date">
        Date
      </span>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-3">
      <span class="Signed-Date">
        Signed
      </span>
    </div>
    <div class="col-9">
      <span class="Date">
        Date
      </span>
    </div>
  </div>
  <div>
    <span class="For-Questions-on-this-report-Contact">
      For Questions on this report,<br>
      Contact:
    </span>
  </div>
</div>
<div class="py-4 mt-5">
  <span class="CopyrightFooter">
    <app-copyright [showStrong]="false"></app-copyright>
  </span>
</div>
<!-- <app-report-screenshots></app-report-screenshots> -->
